import React from "react";
//#region types
import { LinearStepConnectorProps } from "models/propTypes/stateFlowPropTypes";
//#endregion
//#region components
import { LinearProgress } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const LinearStepConnector: React.FC<LinearStepConnectorProps> = (props) => {
  const { active, className, index, isActiveAtIntermediateState, activeStep } = props;

  const value =
    active || (index && index <= activeStep)
      ? 100
      : index && isActiveAtIntermediateState && index - 1 === activeStep
      ? 50
      : 0;

  return (
    <div className={className}>
      {
        <LinearProgress
          classes={{
            root: cssExports.linearStepConnector,
            barColorPrimary: cssExports.linearStepConnectorPrimary,
          }}
          variant="determinate"
          value={value}
        />
      }
    </div>
  );
};

export default LinearStepConnector;
